// import { Texture } from 'texture'
import { GPUComputationRenderer } from './GPGPU'
import { Points, BufferGeometry, BufferAttribute } from 'three'
import { ShaderMaterial } from 'three'
let glsl = v => v[0]
export class Flame {
  constructor ({ renderer, onLoop, onResize, onClean, resX = 128, resY = 128 }) {
    this.onLoop = onLoop
    this.onClean = onClean
    this.onResize = onResize
    this.renderer = renderer
    this.resX = resX
    this.resY = resY
    this.out = {}
    this.works = []
    this.addWork = v => this.works.push(v)

    let gpu = new GPUComputationRenderer(this.resX, this.resY, renderer)

    var dataOutput = gpu.createTexture()
    var variOutput = gpu.addVariable('textureOutput', this.compOutput(), dataOutput)
    variOutput.material.uniforms.time = { value: 0.0 }
    variOutput.material.defines.resolution = ` vec2(${resX.toFixed(1)}, ${resY.toFixed(1)})`
    variOutput.material.defines.pi = `${Math.PI}`

    var dataSimulation = gpu.createTexture()
    var variSimulation = gpu.addVariable('textureSimulation', this.compSimulation(), dataSimulation)
    variSimulation.material.uniforms.time = { value: 0.0 }
    variSimulation.material.defines.resolution = ` vec2(${resX.toFixed(1)}, ${resY.toFixed(1)})`
    variSimulation.material.defines.pi = `${Math.PI}`

    gpu.setVariableDependencies(variSimulation, [variSimulation, variOutput]);
    gpu.setVariableDependencies(variOutput, [variSimulation, variOutput]);

    this.onClean(() => {
      this.works = []
      dataOutput.dispose()
      dataSimulation.dispose()
    })

    let assignPositoin = (texture) => {
      let pixels = texture.image.data
      let w = texture.image.width
      let h = texture.image.height
      let p = 0
      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          pixels[p + 0] = (x - w * 0.5)
          pixels[p + 1] = (y - h * 0.5)
          pixels[p + 2] = 0
          pixels[p + 3] = 1

          p += 4
        }
      }
    }
    assignPositoin(dataOutput)

    // Check for completeness
    var error = gpu.init()
    if (error !== null) {
      console.error(error)
    }

    let makeGeo = () => {
      let getUVandPosition = () => {
        let newArr = []
        var na = 0
        let nn = resX * resY
        var idx = 0

        for (var j = 0; j < resY; j++) {
          for (var i = 0; i < resX; i++) {
            newArr[na + 0] = i / resX
            newArr[na + 1] = j / resY
            newArr[na + 2] = idx / nn
            na += 3
            idx++
          }
        }
        // console.log('total points', idx)
        return new Float32Array(newArr)
      }
      var geometry = new BufferGeometry()
      geometry.setAttribute('position', new BufferAttribute(getUVandPosition(), 3))
      return geometry
    }

    let displayMaterial = new ShaderMaterial({
      transparent: true,
      defines: {
        pi: Math.PI,
        resolution: `vec2(${(resX).toFixed(1)},${(resY).toFixed(1)})`
      },
      uniforms: {
        textureOutput: { value: null },
        textureSimulation: { value: null },
        time: { value: null }
      },
      vertexShader: this.getDisplayVert(),
      fragmentShader: this.getDisplayFrag()
    })

    this.out.mesh = new Points(makeGeo(), displayMaterial)

    this.addWork(() => {
      let time = window.performance.now() * 0.001
      variOutput.material.uniforms.time.value = time
      variSimulation.material.uniforms.time.value = time
      displayMaterial.uniforms.time.value = time

      gpu.compute()

      displayMaterial.uniforms.textureOutput.value = gpu.getCurrentRenderTarget(variOutput).texture
      displayMaterial.uniforms.textureSimulation.value = gpu.getCurrentRenderTarget(variSimulation).texture
    })

    this.onLoop(() => {
      this.works.forEach((v) => { v() })
    })
  }
  compSimulation () {
    return glsl`
      // uniform sampler2D textureSimulation;
      // uniform sampler2D textureOutput;
      uniform float time;

      const mat2 m = mat2( 0.80,  0.60, -0.60,  0.80 );

      float noise( in vec2 p ) {
        return sin(p.x)*sin(p.y);
      }

      float fbm4( vec2 p )
      {
          float f = 0.0;
          f += 0.5000 * noise( p ); p = m * p * 2.02;
          f += 0.2500 * noise( p ); p = m * p * 2.03;
          f += 0.1250 * noise( p ); p = m * p * 2.01;
          f += 0.0625 * noise( p );
          return f / 0.9375;
      }

      float fbm6( vec2 p )
      {
          float f = 0.0;
          f += 0.500000*(0.5+0.5*noise( p )); p = m*p*2.02;
          f += 0.250000*(0.5+0.5*noise( p )); p = m*p*2.03;
          f += 0.125000*(0.5+0.5*noise( p )); p = m*p*2.01;
          f += 0.062500*(0.5+0.5*noise( p )); p = m*p*2.04;
          f += 0.031250*(0.5+0.5*noise( p )); p = m*p*2.01;
          f += 0.015625*(0.5+0.5*noise( p ));
          return f/0.96875;
      }

      float pattern (vec2 p, float time) {
        float vout = fbm4( p + time + fbm6( p + fbm4( p + time )) );
        return (vout);
      }

      void main (void) {
        vec2 uv = gl_FragCoord.xy / resolution.xy;
        vec4 data = texture2D(textureSimulation, uv);
        float tt = time * 0.1;

        data.x = resolution.x * (pattern(uv.xy + cos(0.1 + time * 0.5), time * 0.5));
        // data.y = resolution.x * (pattern(uv.xy + cos(0.2 + time * 0.5), time * 0.5));
        // data.z = resolution.x * (pattern(uv.xy + cos(0.3 + time * 0.5), time * 0.5));

        gl_FragColor = vec4(data);
      }
    `
  }
  compOutput () {
    return glsl`
      // uniform sampler2D textureSimulation;
      // uniform sampler2D textureOutput;
      uniform float time;
      void main (void) {
        vec2 uv = gl_FragCoord.xy / resolution.xy;
        vec4 data = texture2D(textureOutput, uv);
        vec4 simData = texture2D(textureSimulation, uv);
        float tt = time * 0.1;

        data.x = simData.x;
        data.y = data.y;
        data.z = data.z;

        gl_FragColor = vec4(data);
      }
    `
  }

  getDisplayVert () {
    return glsl`
    uniform sampler2D textureOutput;
    uniform sampler2D textureSimulation;
    uniform float time;
    varying vec4 simData;
    varying vec4 outData;
    varying vec4 posData;
    varying vec2 vUv;
    float noise( in vec2 p ) {
      return sin(p.x)*sin(p.y);
    }
      void main (void) {
        vec4 outputData = texture2D(textureOutput, position.xy);
        vec4 simulationData = texture2D(textureSimulation, position.xy);
        simData = simulationData;
        outData = outputData;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(outputData.xyz, 1.0);
        posData = gl_Position;
        vUv = position.xy;
        gl_PointSize = 4.0;
      }
    `
  }

  getDisplayFrag () {
    return glsl`
      uniform float time;

      varying vec4 simData;
      varying vec4 outData;
      varying vec4 posData;
      varying vec2 vUv;

      uniform sampler2D textureSimulation;

      const mat2 m = mat2( 0.80,  0.60, -0.60,  0.80 );

      float noise( in vec2 p ) {
        return sin(p.x)*sin(p.y);
      }

      float fbm4( vec2 p )
      {
          float f = 0.0;
          f += 0.5000 * noise( p ); p = m * p * 2.02;
          f += 0.2500 * noise( p ); p = m * p * 2.03;
          f += 0.1250 * noise( p ); p = m * p * 2.01;
          f += 0.0625 * noise( p );
          return f / 0.9375;
      }

      float fbm6( vec2 p )
      {
          float f = 0.0;
          f += 0.500000*(0.5+0.5*noise( p )); p = m*p*2.02;
          f += 0.250000*(0.5+0.5*noise( p )); p = m*p*2.03;
          f += 0.125000*(0.5+0.5*noise( p )); p = m*p*2.01;
          f += 0.062500*(0.5+0.5*noise( p )); p = m*p*2.04;
          f += 0.031250*(0.5+0.5*noise( p )); p = m*p*2.01;
          f += 0.015625*(0.5+0.5*noise( p ));
          return f/0.96875;
      }

      float pattern (vec2 p) {
        float vout = fbm4( p + time + fbm6( p + fbm4( p + time )) );
        return abs(vout);
      }

      void main (void) {
        vec2 hpt = gl_PointCoord.xy - vec2(0.5);
        if (length(hpt) < 0.5) {
          vec2 pt = vUv;
          float rx = pattern(pt.xy + cos(0.1 * pi * 2.0 + time * 0.5));
          float ry = pattern(pt.xy + cos(0.2 * pi * 2.0 + time * 0.5));
          float rz = pattern(pt.xy + cos(0.3 * pi * 2.0 + time * 0.5));

          gl_FragColor = vec4(rx, ry, rz, 0.01) * 0.45 + 0.25;
          gl_FragColor.a = 0.075;
        } else {
          discard;
        }
      }
    `
  }
}
